import {
  AiStatus,
  Default,
  Blue,
  Orange,
  Purple,
  Gold,
  Green,
  Cyan,
  White,
} from 'components/tag/StatusColorConfig';

import { ActionTaken, EntryType } from 'types/cash';
import { StatusConfig } from 'types/tag/StatusConfigType';

export type CashStatusTypes = EntryType | ActionTaken;

export const CASH_STATUS_CONFIG: Record<CashStatusTypes, StatusConfig> = {
  MATCH: {
    ...AiStatus,
    title: 'Matched',
  },
  RECONCILE: {
    ...AiStatus,
    title: 'Reconciled',
  },
  CATEGORIZE: {
    ...AiStatus,
    title: 'Categorized',
  },
  AI_COULD_NOT_SUGGEST: {
    ...Default,
    title: 'No Suggestion',
  },
  USER_REJECTED: {
    ...Default,
    title: 'User Rejected',
  },
  USER_REJECTED_MATCH: {
    ...Blue,
    title: 'Match',
  },
  USER_REJECTED_RECONCILE: {
    ...Purple,
    title: 'Reconcile',
  },
  USER_REJECTED_CATEGORIZE: {
    ...Orange,
    title: 'Categorize',
  },
  APPROVED_VIA_CATEGORIZE: {
    ...AiStatus,
    title: 'Categorized',
  },
  APPROVED_VIA_MATCH: {
    ...AiStatus,
    title: 'Matched',
  },
  APPROVED_VIA_RECONCILE: {
    ...AiStatus,
    title: 'Reconciled',
  },
  MANUAL_APPROVED_CATEGORIZE: {
    ...Default,
    title: 'Manually Categorized',
  },
  MANUAL_APPROVED_MATCH: {
    ...Default,
    title: 'Manually Matched',
  },
  MANUAL_APPROVED_RECONCILE: {
    ...Default,
    title: 'Manually Reconciled',
  },
  BILL: {
    ...Gold,
    title: 'Bill',
  },
  BILL_PAYMENT: {
    ...Gold,
    title: 'B-Pay',
  },
  EXPENSE: {
    ...Gold,
    title: 'Exp',
  },
  BILL_CREDIT_MEMO: {
    ...Gold,
    title: 'B-CM',
  },
  INVOICE: {
    ...Green,
    title: 'Inv',
  },
  INVOICE_PAYMENT: {
    ...Green,
    title: 'Inv-Pay',
  },
  INVOICE_CREDIT_MEMO: {
    ...Green,
    title: 'I-CM',
  },
  BANK_TRANSFER: {
    ...Cyan,
    title: 'Xfer',
  },
  BANK_DEPOSIT: {
    ...Cyan,
    title: 'Dep',
  },
  JOURNAL_ENTRY: {
    ...White,
    title: 'JE',
  },
  CREDIT_CARD_PAYMENT: {
    ...Blue,
    title: 'CC-Pay',
  },
};
